'use strict';

angular.module('systemOwnerReviewControllers.ReviewUniquePermissions')

    .directive('uniquePermissionCard', [function () {
        return {
            scope: {
                model: '=',
                readOnly: '=',
                layoutRatio: '=?',
                toRemove: '&',
                toCancelRemove: '&'
            },
            restrict: 'AE',
            templateUrl: require('./UniquePermissionCard.tpl.html'),
            controller: ['$scope', function ($scope) {
                // Display or not actions
                $scope.displayActions = false;
                $scope.isRemoved = false;

                $scope.showOrHideActions = function ($event) {
                    if ($scope.readOnly) return;
                    $scope.displayActions = !$scope.displayActions;
                    $event.stopPropagation();
                }

                // Remove permission
                $scope.remove = function () {
                    $scope.toRemove().then(function () {
                    });
                }

                // Cancel Remove permission
                $scope.cancelRemove = function () {
                    $scope.toCancelRemove().then(function () {
                    });
                }
            }],
            link: function (scope, element, attrs) {
                scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                    column: 'col-md-4'
                };
            }
        };
    }]);